import { render, staticRenderFns } from "./CartRestaurant.vue?vue&type=template&id=471d674c"
import script from "./CartRestaurant.vue?vue&type=script&lang=js"
export * from "./CartRestaurant.vue?vue&type=script&lang=js"
import style0 from "./CartRestaurant.vue?vue&type=style&index=0&id=471d674c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports